import { useState } from "react";

const useSignUp = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const signUp = async (formData, resetForm) => {
    setLoading(true);
    setError(null);
    setSuccess(null);

    console.log("Attempting to sign up with:", formData);

    try {
      const dataToSend = new FormData();
      dataToSend.append("fullname", formData.fullname);
      dataToSend.append("address", formData.address);
      dataToSend.append("email", formData.email);
      dataToSend.append("contact", formData.contactNumber);
      dataToSend.append("password", formData.password);
      dataToSend.append("role", formData.role);
      dataToSend.append("status", "Pending");

      // Append multiple files as 'document' (Multer will handle it as array)
      if (formData.documents && formData.documents.length > 0) {
        formData.documents.forEach((file) => {
          dataToSend.append("document", file); // ✅ Use 'document' for each file
        });
      }

      const response = await fetch("https://inaaniserver-50c4305cc7f7.herokuapp.com/users/add", {
        method: "POST",
        body: dataToSend,
        headers: {
          // Don't set Content-Type, let fetch handle it with boundary
        },
      });

      const data = await response.json();
      console.log("Response from server:", data);

      if (data.error) {
        setError(data.message);
        console.error("Error from server:", data.message);
        return { success: false, error: data.message };
      } else {
        setSuccess(data.message);
        console.log("User successfully added:", data.message);
        resetForm();
        return { success: true, error: null };
      }
    } catch (err) {
      setError("Something went wrong. Please try again later.");
      console.error("Error during fetch:", err);
      return { success: false, error: "Something went wrong. Please try again later." };
    } finally {
      setLoading(false);
    }
  };

  return { signUp, loading, error, success };
};

export default useSignUp;
